import {DateRangeType} from "../type/date-range-filter.type";
import dayjs  from 'dayjs';
import Locale from "../../../../core/locale/locale";


export const formatDateForDisplay = (date: string) => {
    return dayjs(date,Locale.dateFormat).format(Locale.displayDateLong);
};


export const getDateRangeForAPI = (type: DateRangeType): { startDate: string; endDate: string } => {
    const today = dayjs();
    const yesterday = today.subtract(1, 'day');
    switch (type) {
        case "All":
            return { startDate: "", endDate: "" };

        case "Today":
            return { startDate: today.format(Locale.dateFormat), endDate: today.format(Locale.dateFormat) };

        case "Yesterday":
            return { startDate: yesterday.format(Locale.dateFormat), endDate: yesterday.format(Locale.dateFormat) };

        case "Last 7 days": {
            const startDate = today.subtract(6, "day");
            return { startDate: startDate.format(Locale.dateFormat), endDate: today.format(Locale.dateFormat) };
        }

        case "Last 30 days": {
            const startDate = today.subtract(29, "day");
            return { startDate: startDate.format(Locale.dateFormat), endDate: today.format(Locale.dateFormat) };
        }

        case "Last 60 days": {
            const startDate = today.subtract(59, "day");
            return { startDate: startDate.format(Locale.dateFormat), endDate: today.format(Locale.dateFormat) };
        }

        case "This Month": {
            const startDate = today.startOf("month");
            return { startDate: startDate.format(Locale.dateFormat), endDate: today.format(Locale.dateFormat) };
        }

        default:
            return { startDate: "", endDate: "" };
    }
};
